import { Decimal } from 'decimal.js';
/** Order totals and payments are whole cents, and AR still compares at cents so a stray sub-cent value never decides open versus paid. */
export function roundToCents(value) {
    return new Decimal(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
}
//# sourceMappingURL=round-to-cents.js.map